import React, { Component, Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Modal, Button, Image } from "react-bootstrap";
import moment from "moment";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import InfoToolTip from "../../reusableComponents/InfoTooltipComponent";
import { makeStyles } from "@material-ui/core/styles";
import RePaymentCustomerEditModel from "./OrderRequest/RePaymentCustomerEditModel";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import CarouselMain from "./OrderRequest/CarouselMain";
import {
  create_order_vedor_side,
  razor_pay_create_order,
  razor_payment,
  edit_order_vendor_side_payment,
  apply_offer_code,
  editTransaction,
} from "../../../store/actions/OrderingAction/vendorOrderingAction";
import {
  SET_ORDER_DONATION,
  SET_ORDER_TIP,
  UPDATE_CART_FILTERED_MENU_ORDER,
  SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
  APPLY_OFFER_VENDOR,
} from "../../../store/types";
import store from "../../../store/store";
import Alert from "react-s-alert";
import {
  CLEAR_CART_DATA,
  CLEAR_CART_DATA_USER_DATA,
} from "../../../store/types";
import { DEFAULT_ITEM_IMAGE } from "../../../enums/GlobalEnums";
import { NOTAVAILABLEIMAGE } from "../../../enums/GlobalEnums";
import VendorLearnMore from "../../reusableComponents/allPopupReusable/learnMorePopup/VendorLearnMore";
import isEmpty from "../../../store/validation/is-Empty";
import { ORDER_RAZORPAY_KEY } from "../../../config/Keys";
import { getPendingPayment } from "../../../function/getPendingPayment";
import { ITEMTYPEVEG, ORDER_TYPE_NAME } from "../../../enums/OrderEnums";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    border: "0.5px solid #9E9E9E;",
    borderRadius: "5px",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

class ReRightComponentOrderRequest extends Component {
  state = {
    tip: 0,
    tipAmount: 0,
    totalTipAmount: 0,
    donationId: 0,
    donationAmount: 0,
    totalDonationAmount: 0,
    open: false,
    openTract: false,
    total_amount: 0,
    total_charges: 0,
    onlinePayment: true,
    transactional_id: 0,
    orderId: 0,
  };


  //const dispatch = useDispatch();
  loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  // const __DEV__ = document.domain === "localhost";

  //const [name, setName] = useState("Mehul");

  async displayRazorpay(
    total,
    userId,
    name,
    phoneNo,
    email,
    orderId,
    allOrderData
  ) {
    const res = await this.loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const onSuccess = (data, orderId) => {
      this.setState({
        transactional_id: data.transactional._id,
        orderId: orderId,
      });
      // console.log("****STart*********");
      // console.log(this.state.transactional._id);
      // console.log(data.transactional._id);
      // console.log("****End*********");

      const onSuccessHandler = (response) => {
        const formData = {
          razorpay_payment_id: response.razorpay_payment_id,
          transactional_id: data.transactional._id,
          isEvent: false,
          order_id: orderId,
          restaurant_id: this.props.onboarding._id,
          transaction_type: "RAZORPAY",
          user_id: userId,
          currency: "INR",
        };

        if (
          allOrderData &&
          allOrderData.donation &&
          allOrderData.donation.amount
        ) {
          formData.donation = {};
          formData.donation.amount = allOrderData.donation.amount;
        }

        let orderData = {
          id: orderId,
          paid: true,
          transactionId: data?.transactional?._id,
          txnId: data?.transactional?.transactionNumber,
          method: "RAZORPAY",
          amount: total,
          type: "PAYMENT",
          date: Date.now(),
          paymentType: allOrderData?.payment_method,
        };
        this.props.editTransaction(orderData);

        const token = this.props.auth.user.accessToken;
        this.props.razor_payment(
          token,
          formData,
          this.onSuccessCallFinalApi,
          orderId
        );
      };

      const onFailure = (response) => {
        const formData = {};
        //formData.transactional_id = data._id;
        formData.payment_status = 3;
        formData.paynow = true;
        formData.payment_method = this.props.user_data.payment_method;
        formData.transactional_id = data.transactional._id;
        formData.razorpay_payment_id = response.error.metadata.payment_id;
        const token = this.props.auth.user.accessToken;
        this.props.edit_order_vendor_side_payment(token, formData, orderId);
        let orderData = {
          id: orderId,
          paid: false,
          transactionId: data.transactional?._id,
          txnId: data?.transactional?.transactionNumber,
          method: "RAZORPAY",
          amount: total,
          type: "PAYMENT",
          date: Date.now(),
          paymentType: allOrderData?.payment_method,
        };
        this.props.editTransaction(orderData);
      };

      const options = {
        //key: __DEV__ ? "rzp_test_7P1z0w07gah1Uv" : "PRODUCTION_KEY",
        key: ORDER_RAZORPAY_KEY,
        currency: data.currency,
        amount: data.amount.toString(),
        order_id: data.id,
        name: "Amealio",
        description: "Amealio Ordering Payment",
        method: {
          netbanking: false,
          card: true,
          wallet: false,
          upi: false,
        },
        // config: {
        //   hide: [
        //     {
        //       method: "upi",
        //     },
        //   ],
        // },
        //image: "http://localhost:1337/logo.svg",
        handler: function (response) {
          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);

          // const formData = {
          //   razorpay_payment_id: response.razorpay_payment_id,
          //   transactional_id: this.state.transactional_id,
          //   isEvent: false,
          // };
          // this.props.razor_payment(
          //   this.state.token,
          //   formData,
          //   this.onSuccessCallFinalApi
          // );
          onSuccessHandler(response);
        },
        prefill: {
          name: name,
          email: email,
          contact: phoneNo,
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
      paymentObject.on("payment.failed", function (response) {
        onFailure(response);
        // alert(response.error.code);
        // alert(response.error.description);
        // alert(response.error.source);
        // alert(response.error.step);
        // alert(response.error.reason);
        // alert(response.error.metadata.order_id);
        // alert(response.error.metadata.payment_id);
      });
    };

    const formData = {
      amount: parseFloat(total).toFixed(2),
      user_id: userId,
      refModel: "User",
      message: "Testing payment",
      currency: "INR",
      isEvent: false,
      receipt: orderId,
      //order_id: orderId,
      orderId: orderId,
      restaurant_id: this.props.onboarding._id,
      transaction_type: "RAZORPAY",
    };
    //formData = { donation: {} };
    // if (data && data.donation && data.donation.amount) {
    //   formData.donation = {};
    //   formData.donation.amount = data.donation.amount;
    // }

    const token = this.props.auth.user.accessToken;
    this.setState({ token: token });
    this.props.razor_pay_create_order(token, formData, onSuccess, orderId);

    // const data = await fetch("http://localhost:1337/razorpay", {
    //   method: "POST",
    // }).then((t) => t.json());
  }

  setOpenTract = () => {
    this.setState({ open: false, openTract: true });
  };

  prepareAddOn = (data) => {
    let addOnsNames = [];
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].options.length; j++) {
        addOnsNames.push(data[i].options[j].name);
      }
    }
    return addOnsNames.toString();
  };

  onError = (err) => (e) => {
    Alert.error(`<h4>${err ? err : "Unable to process your order"}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };
  calcCharges = (data) => {
    let price = 0;
    let charges = 0;
    // for (let i = 0; i < data.length; i++) {
    //   price = data[i][0].finalPrice * data[i][0].quantity + price;
    // }
    // for (let i = 0; i < data.length; i++) {
    //   charges = data[i][0].charges * data[i][0].quantity + charges;
    // }
    if (this.props.user_data.isOfferApplied) {
      if (this.props.user_data.isPercentage === false) {
        if (this.props.user_data.discountAmount === price) {
          return 0;
        }
      }
      //  else {
      //   return charges.toFixed(2);
      // }
    } else {
      return charges.toFixed(2);
    }

    // return charges.toFixed(2);
  };

  calcTotal = (data) => {
    let price = 0;
    // for (let i = 0; i < data.length; i++) {
    //   price = data[i][0].finalPrice * data[i][0].quantity + price;
    // }
    //this.setState({ total_amount: price.toFixed(2) });

    return price.toFixed(2);
  };

  calcFinalTotal = (data) => {
    let charges = 0;
    // for (let i = 0; i < data.length; i++) {
    //   charges = data[i][0].charges * data[i][0].quantity + charges;
    // }

    let price = 0;
    // for (let i = 0; i < data.length; i++) {
    //   price = data[i][0].finalPrice * data[i][0].quantity + price;
    // }

    let chargesData =
      this.props.user_data.discountAmount === price ? 0 : charges;

    let finalTotal = chargesData + price;
    if (
      this.props.user_data &&
      this.props.user_data.tip &&
      this.props.user_data.tip.amount
    ) {
      finalTotal = finalTotal + this.props.user_data.tip.amount;
    }
    if (
      this.props.user_data &&
      this.props.user_data.donation &&
      this.props.user_data.donation.amount
    ) {
      finalTotal = finalTotal + this.props.user_data.donation.amount;
    }

    if (this.props.user_data.isOfferApplied) {
      if (this.props.user_data.isPercentage) {
        let discount = (
          (finalTotal * this.props.user_data.discountAmount) /
          100
        ).toFixed(2);
        return (finalTotal - discount).toFixed(2);
      } else {
        // let discount = (
        //   finalTotal - this.props.user_data.discountAmount
        // ).toFixed(2);
        return (finalTotal - this.props.user_data.discountAmount).toFixed(2);
      }
    } else {
      return finalTotal.toFixed(2);
    }
  };

  calcTips = () => {
    const totalAmount = this.calcTotal(
      !isEmpty(this.props?.cart_data) && this.props.cart_data
    );
    const totalCharges = this.calcCharges(
      !isEmpty(this.props?.cart_data) && this.props.cart_data
    );

    let finalTip = 0;
    if (
      this.props.user_data &&
      this.props.user_data.tip &&
      this.props.user_data.tip.value
    ) {
      let totalTips = parseFloat(totalAmount) + parseFloat(totalCharges);

      finalTip =
        totalTips * !isEmpty(this.props?.user_data?.tip?.value) &&
        this.props.user_data.tip.value / 100;
    }
    // const formData = {
    //   tip: {
    //     value: tipAmount,
    //     amount: 48,
    //   },
    // };
    // store.dispatch({
    //   type: SET_ORDER_TIP,
    //   payload: formData,
    // });

    return finalTip.toFixed(2);
  };

  setTips = (tipId, tipValue) => {
    this.setState({ tip: tipId, tipAmount: tipValue });
    const totalAmount = this.calcTotal(this.props.cart_data);
    const totalCharges = this.calcCharges(this.props.cart_data);
    let finalTip = 0;
    let totalTips = parseFloat(totalAmount) + parseFloat(totalCharges);

    finalTip = (totalTips * tipValue) / 100;

    const formData = {
      value: tipValue,
      amount: finalTip,
    };

    store.dispatch({
      type: SET_ORDER_TIP,
      payload: formData,
    });
    // this.props.addTips(calcTips);
  };

  setDonation = (donId, donAmount) => {
    this.setState({ donationId: donId, donationAmount: donAmount });

    if (donAmount === 0) {
      this.setState({ totalDonationAmount: 0 });
    } else {
      this.setState({ totalDonationAmount: donAmount });
      // this.props.addTips(calcTips);
    }
    const formData = {
      amount: donAmount,
    };

    store.dispatch({
      type: SET_ORDER_DONATION,
      payload: formData,
    });
  };

  onUpdateOrder = (data, orderId) => {
    const formData = { donation: {} };
    if (data && data.donation && data.donation.amount) {
      formData.donation.amount = data.donation.amount;
      formData.donation.order_id = orderId;
      formData.paynow = true;
      formData.payment_method = this.props.user_data.payment_method;
      const token = this.props.auth.user.accessToken;
      this.props.edit_order_vendor_side_payment(
        token,
        formData,
        orderId,
        this.onSuccessPayment
      );
    } else {
      this.onSuccessPayment();
    }
  };

  onSuccess = (data, orderId) => {
    if (data.payment_method === 0 || data.payment_method === 6) {
      // cash
      //this.setState({ open: true });
      // alert("ORDER CREATED");
      this.props.setShow();
      this.props.setData(data);
      //this.onUpdateOrder(data, orderId);
      Alert.success(`<h4>Order Created  Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      // store.dispatch({
      //   type: CLEAR_CART_DATA,
      //   //payload: formData,
      // });
      // store.dispatch({
      //   type: CLEAR_CART_DATA_USER_DATA,
      //   //payload: formData,
      // });
      // this.props.history.push("/orderdashboard");
    } else {
      this.displayRazorpay(
        data.total_amount,
        data.user_details.userId,
        data.user_details.first_name,
        data.user_details.mobile_number,
        data.user_details.email,
        orderId,
        data
      );
    }
    //this.props.history.push("/orderdashboard");
  };

  onSuccessPayment = (data) => {
    // this.props.setShow();
    // this.props.setData(data);

    // Alert.success(`<h4>Order Created  Successfully</h4>`, {
    //   position: "top-right",
    //   effect: "bouncyflip",
    //   beep: true,
    //   html: true,
    //   timeout: 3000,
    //   offset: 35,
    // });
    // store.dispatch({
    //   type: CLEAR_CART_DATA,
    //   //payload: formData,
    // });
    // store.dispatch({
    //   type: CLEAR_CART_DATA_USER_DATA,
    //   //payload: formData,
    // });
    this.props.history.push("/orderdashboard");
  };

  onSuccessCallFinalApi = (data, orderId) => {
    this.setState({ transactional_id: data._id, onlinePayment: false });
    //this.onClickProceed();

    const formData = {};
    formData.transactional_id = data?._id;
    formData.payment_status = 1;
    formData.paynow = true;
    formData.payment_method = this.props.user_data.payment_method;
    const token = this.props.auth.user.accessToken;
    this.props.edit_order_vendor_side_payment(
      token,
      formData,
      orderId,
      this.onSuccessPayment
    );
  };

  calcDiscount = (data) => {
    let charges = 0;
    for (let i = 0; i < data.length; i++) {
      charges = data[i][0].charges * data[i][0].quantity + charges;
    }

    let price = 0;
    for (let i = 0; i < data.length; i++) {
      price = data[i][0].finalPrice * data[i][0].quantity + price;
    }
    let finalTotal = charges + price;

    if (
      this.props.user_data &&
      this.props.user_data.tip &&
      this.props.user_data.tip.amount
    ) {
      finalTotal = finalTotal + this.props.user_data.tip.amount;
    }
    if (
      this.props.user_data &&
      this.props.user_data.donation &&
      this.props.user_data.donation.amount
    ) {
      finalTotal = finalTotal + this.props.user_data.donation.amount;
    }

    if (this.props.user_data.isOfferApplied) {
      if (this.props.user_data.isPercentage) {
        let discount = (
          (finalTotal * this.props.user_data.discountAmount) /
          100
        ).toFixed(2);
        return discount;
      } else {
        let discount = this.props.user_data.discountAmount.toFixed(2);
        return discount;
      }
    } else {
      return "0";
    }
  };

  onSuccessCupon = () => { };

  onFailureCoupon = (err) => {
    Alert.error(`<h4>${err.response.data.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  checkAndApplyOffer = (code) => {
    const token = this.props.auth.user.accessToken;
    const vendorId = this.props.auth.user.VendorUser._id;
    this.props.apply_offer_code(
      token,
      code,
      vendorId,
      this.onSuccessCupon,
      (err) => this.onFailureCoupon(err)
    );
  };

  incrementHandler = (itemId, qty, index) => {
    let cartData = JSON.parse(JSON.stringify(this.props.cart_data));
    cartData[index][0].quantity = qty + 1;
    store.dispatch({
      type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
      payload: cartData,
    });

    let globalQty = 0;
    for (let i = 0; i < this.props.vendor_filtered_menu.length; i++) {
      for (
        let j = 0;
        j < this.props.vendor_filtered_menu[i].items.length;
        j++
      ) {
        if (this.props.vendor_filtered_menu[i].items[j]._id === itemId) {
          globalQty =
            this.props.vendor_filtered_menu[i].items[j].cartLength + 1;
          break;
        }
      }
    }

    const formData = {};
    formData.cartLength = globalQty;
    formData.id = itemId;
    store.dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });
  };

  decrementHandler = (itemId, qty, index) => {
    let cartData = JSON.parse(JSON.stringify(this.props.cart_data));
    if (cartData[index][0].quantity - 1 === 0) {
      cartData.splice(index, 1);
    } else {
      cartData[index][0].quantity = qty - 1;
    }
    store.dispatch({
      type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
      payload: cartData,
    });

    let globalQty = 0;
    for (let i = 0; i < this.props.vendor_filtered_menu.length; i++) {
      for (
        let j = 0;
        j < this.props.vendor_filtered_menu[i].items.length;
        j++
      ) {
        if (this.props.vendor_filtered_menu[i].items[j]._id === itemId) {
          globalQty =
            this.props.vendor_filtered_menu[i].items[j].cartLength - 1;
          break;
        }
      }
    }
    const formData = {};
    formData.cartLength = globalQty;
    formData.id = itemId;
    store.dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });
  };

  onClickProceed = () => {
    const formData = this.props.user_data;
    // const exisitingCartData = this.props.user_data;
    const exisitingCartData = {};
    exisitingCartData.base_amount = formData.base_amount;
    exisitingCartData.tax_amount = formData.tax_amount;
    exisitingCartData.total_amount = formData.total_amount;
    exisitingCartData.payment_status = 1;
    exisitingCartData.payment_method = formData.payment_method;

    exisitingCartData.paynow = true;
    if (this.props.dataActionBy.toString() !== "PAYLATER") {
      exisitingCartData.max_time = 0;
    }

    // if (
    //   formData.payment_method === 4 ||
    //   (formData.payment_method === 3 && this.state.onlinePayment)
    // ) {
    //   // razro pay
    //   this.displayRazorpay(
    //     formData.total_amount,
    //     formData.user_details.userId,
    //     formData.user_details.first_name,
    //     formData.user_details.mobile_number,
    //     formData.user_details.email
    //   );
    // } else {
    //   if (formData.payment_method === 4 || formData.payment_method === 3) {
    //     formData.transactional_id = this.state.transactional_id;
    //   }

    if (
      formData.payment_method === 6 ||
      formData.payment_method === 8 ||
      formData.payment_method === 9
    ) {
      const token = this.props.auth.user.accessToken;
      // delete formData._id;

      let orderData = {
        id: formData._id,
        paid: formData?.payment_method === 6 ? false : true,
        method: formData?.payment_method === 6 ? "PAYLATER" : "EXTERNAL",
        amount: getPendingPayment(formData)
          ? getPendingPayment(formData)
          : formData.total_amount,
        type: formData?.payment_method === 6 ? "PAYLATER" : "PAYMENT",
        date: Date.now(),
        paymentType: formData?.payment_method,
      };
      this.props.editTransaction(orderData);

      this.props.edit_order_vendor_side_payment(
        token,
        exisitingCartData,
        formData._id,
        this.onSuccessPayment
      );
    } else {
      this.displayRazorpay(
        exisitingCartData.total_amount,
        formData.user_id,
        formData.user_details.first_name,
        formData.user_details.mobile_number,
        formData.user_details.email,
        formData._id
      );
    }
  };

  calcTaxes = (data) => {
    let tax = Object.values(data).reduce(
      (a, b) => parseFloat(a || 0) + parseFloat(b || 0),
      0
    );
    return tax?.toFixed(2);
  };

  render() {
    try {
      const { cart, payment, cart_data, onboarding, user_data } = this.props;
      const { tip, open, openTract, donationId } = this.state;

      return (
        <React.Fragment>
          <Container fluid>
            {!this.props.onlyPayment && (
              <>
                <RePaymentCustomerEditModel
                  cart={cart}
                  payment={payment}
                  cart_data={cart_data}
                  orderBufferTime={onboarding.orderBufferTime}
                />
                {cart !== 0 && (
                  <div>
                    <h6>
                      {" "}
                      {!this.props.payment && !this.props.cart
                        ? "Old Item Details"
                        : "Items Added to Cart"}
                    </h6>
                    {/* {payment ? (
                    <div
                      className="f14-500"
                      style={{ color: "#2196F3", cursor: "pointer" }}
                      onClick={() => this.props.history.push("/orderrequest")}
                    >
                      Add More Items to Cart
                    </div>
                  ) : (
                    <> </>
                  )} */}

                    {!isEmpty(this.props?.user_data?.order_items) &&
                      this.props?.user_data?.order_items.map((item, index) => (
                        <Fragment key={index}>
                          <div
                            className="row f10-400"
                            style={{ marginTop: "30px" }}
                          >
                            <Col md={3} xs={3}>
                              <img
                                src={
                                  (item && item.item && item.item.images[0]) ||
                                  NOTAVAILABLEIMAGE
                                }
                                width="60px"
                              // width="100%"
                              />
                            </Col>
                            <Col md={5} xs={5}>
                              <h6>
                                {ITEMTYPEVEG.map((type, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      {item?.item?.itemType === type?.value ? (
                                        <Image
                                          width="15px"
                                          height="15px"
                                          src={type.url}
                                          alt={type.title}
                                          title={type.title}
                                          fluid
                                        />
                                      ) : null}
                                    </React.Fragment>
                                  );
                                })}{" "}
                                {/* {item.item.name} */}
                                {item && item.item && item.item.name}{" "}
                              </h6>
                              {item && item.item && item.item.description}
                              {item && item?.item && item?.item?.customised ? (
                                <p style={{ color: "#EE3A23" }}>Customized</p>
                              ) : null}
                              {item &&
                                item.item &&
                                item.item &&
                                item &&
                                item.item &&
                                item.item.addOns &&
                                item &&
                                item.item &&
                                item.item.addOns.length > 0 ? (
                                <p>
                                  AddOn :{" "}
                                  {this.prepareAddOn(
                                    item && item.item && item.item.addOns
                                  )}
                                </p>
                              ) : (
                                <></>
                              )}

                              {item &&
                                item.item &&
                                item.item &&
                                item &&
                                item.item &&
                                item.item.notes ? (
                                <>
                                  Notes : {item && item.item && item.item.notes}{" "}
                                </>
                              ) : (
                                <> </>
                              )}
                            </Col>
                            <Col md={1} xs={1} className="p-0">
                              <span className="f12-700">
                                <i
                                  className="fa fa-times"
                                  aria-hidden="true"
                                ></i>{" "}
                                {item && item.quantity}
                              </span>
                            </Col>
                            <Col md={3} xs={3}>
                              <div className="f12-700">
                                ₹ {item?.size?.price * item?.quantity}
                              </div>
                            </Col>
                          </div>
                          {!payment && (
                            <div class="" align="center">
                              <div class="row">
                                <div className="col-1 p-0 ml-4">
                                  <button
                                    type="button"
                                    class="p-0 btn btn-link"
                                    // onClick={decrementHandler}
                                    onClick={() =>
                                      this.decrementHandler(
                                        item && item.item && item.item.itemId,
                                        item && item.item && item.item.quantity,
                                        index
                                      )
                                    }
                                  >
                                    <img
                                      src={require("../../../assets/images/superadmin/ordericon/less.svg")}
                                      alt="Minus"
                                      title="Minus"
                                      class="img-fluid"
                                      width="60px"
                                    />
                                  </button>
                                </div>
                                <div className="col-1 p-0 mr-3">
                                  <input
                                    //placeholder={item && item.item && item.item.quantity}
                                    value={
                                      item && item.item && item.item.quantity
                                    }
                                    class="enInputValueOnly f12-700"
                                    width="30px"
                                    onChange={() => { }}
                                  />
                                </div>
                                <div className="col-1 p-0">
                                  <button
                                    type="button"
                                    class="p-0 btn btn-link"
                                    onClick={() =>
                                      this.incrementHandler(
                                        item && item.item && item.item.itemId,
                                        item && item.item && item.item.quantity,
                                        index
                                      )
                                    }
                                  //onClick={incrementHandler}
                                  // onClick={() => setShowRepeatSize(true)}
                                  >
                                    <img
                                      src={require("../../../assets/images/superadmin/ordericon/add.svg")}
                                      alt="add "
                                      title="add"
                                      class="img-fluid"
                                      width="60px"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                          <hr />
                        </Fragment>
                      ))}

                    {/* <div
              style={{
                paddingTop: !this.props.payment && !this.props.cart && "10%",
              }}
            >
              <h6>
                {!this.props.payment &&
                  !this.props.cart &&
                  "Substituted Item Selected"}
              </h6>
              <div className="row  f10-400" style={{ marginTop: "30px" }}>
                <Col md={3}>
                  <img
                    src={require("../../../assets/images/Orders/Mask Group 113.png")}
                    // width="100%"
                  />
                </Col>
                <Col md={9}>
                  <h6>
                    <img
                      src={require("../../../assets/images/superadmin/ordericon/veg.svg")}
                      width="15px"
                      heigth="15px"
                    />{" "}
                    Mexican Wave Pizza
                  </h6>
                  Small
                  <p style={{ color: "#EE3A23  " }}>Customized</p>
                  <p>
                    Crust: New Hand Tossed Add On: Onion, Capsicum, Mushroom
                  </p>
                </Col>
              </div>
            </div> */}
                    {/* Increments & decrements */}
                    <br />
                    {!payment && (
                      <div>
                        {/* <div class="pl-md-2 enPartyPersonEdit" align="center">
                  <div class=" align-items-center">
                    <button
                      type="button"
                      class="p-0 btn btn-link"
                      onClick={this.decrementHandler}
                    >
                      <img
                        src={require("../../../assets/images/superadmin/ordericon/less.svg")}
                        alt="Minus"
                        title="Minus"
                        class="img-fluid"
                        width="30px"
                      />
                    </button>
                    <input
                      placeholder="00"
                      value={cart}
                      class="enInputValueOnly f12-700"
                      width="30px"
                      onChange={() => {}}
                    />
                    <button
                      type="button"
                      class="p-0 btn btn-link"
                      onClick={this.incrementHandler}
                    >
                      <img
                        src={require("../../../assets/images/superadmin/ordericon/add.svg")}
                        alt="Minus"
                        title="Minus"
                        class="img-fluid"
                        width="30px"
                      />
                    </button>
                  </div>
                </div> */}
                        <hr />
                        <h6>Suggested item</h6>
                        <br />
                        <div>
                          <CarouselMain />
                          {/* <div
                    id="carouselExampleControls"
                    class="carousel slide"
                    data-ride="carousel"
                  >
                    <ol class="carousel-indicators">
                      {suggestions.map((data, index) => {
                        return (
                          <li
                            data-target="#carouselExampleControls"
                            data-slide-to={`${index}`}
                            class={`${index === 0 && `active`}`}
                            key={index}
                          ></li>
                        );
                      })}
                    </ol>
                    <div class="carousel-inner f12-400">
                      {suggestions.map((data) => {
                        return (
                          <div
                            class={`carousel-item ${data.id === 0 && `active`}`}
                          >
                            <div class="card" style={{ width: "100%" }}>
                              <img
                                class="card-img-top"
                                src={require("../../../assets/images/Orders/Mask Group 113.png")}
                                alt="Card image"
                                style={{ width: "100%", maxHeight: "150px" }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "40%",
                                  left: "5%",
                                }}
                                class="bottom-left"
                                className="badge badge-warning"
                              >
                                Best Selling
                              </div>
                              <div class="card-body">
                                <table style={{ width: "100%" }}>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <img
                                          src={require("../../../assets/images/superadmin/ordericon/veg.svg")}
                                          width="15px"
                                          heigth="15px"
                                        />
                                      </td>
                                      <td>
                                        <span className="f12-700">
                                          {data.title}
                                        </span>
                                        <br />
                                        <img
                                          src={require("../../../assets/images/superadmin/ordericon/star.svg")}
                                          width="10px"
                                          heigth="10px"
                                        />
                                        4.2 (550 reviews)
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <img
                                          src={require("../../../assets/images/superadmin/ordericon/rupees.svg")}
                                          width="30px"
                                        />
                                      </td>
                                      <td>
                                        <span className="f12-700">
                                          {data.price}
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <button
                                  type="button"
                                  class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                                  title="Save Button"
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {/* <a
                      class="carousel-control-prev"
                      href="#carouselExampleControls"
                      role="button"
                      data-slide="prev"
                      style={{ bottom: 0 }}
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="sr-only">Previous</span>
                    </a>
                    <a
                      class="carousel-control-next"
                      href="#carouselExampleControls"
                      role="button"
                      data-slide="next"
                      style={{ bottom: 0 }}
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="sr-only">Next</span>
                    </a> 
                  </div> */}

                          {/*  */}
                        </div>
                        <br />

                        {/* <h6>Add Notes For Kitchen</h6> */}
                        <hr />
                        <Fragment>
                          <div style={{ backgroundColor: "#F8F8F8" }}>
                            <div
                              style={{
                                paddingTop: "10px",
                                paddingLeft: "10px",
                              }}
                              className="d-flex justify-content-between"
                            >
                              <h6>Add Tip</h6>{" "}
                              <VendorLearnMore
                                heading="Add Tip"
                                paragraphText="‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy."
                              />
                            </div>
                            <br />
                            <Row
                              style={{ marginLeft: "3%" }}
                              className="superadmin-orderscomponent-main f12-400"
                            >
                              {tips.map((data) => {
                                return (
                                  <Col
                                    xs={4}
                                    sm={4}
                                    md={4}
                                    // className="p-0"
                                    align="center"
                                    // onClick={() => {
                                    //   this.setState({ tip: data.id });
                                    // }}
                                    onClick={() =>
                                      this.setTips(data.id, data.amount)
                                    }
                                    key={data.id}
                                  >
                                    <div
                                      className={`take-away-order-select 
                                  ${tip === data.id &&
                                        `take-away-order-select-selected`
                                        }`}
                                      style={{
                                        padding: "10px",
                                        // marginRight: "12%",
                                        marginBottom: "8%",
                                      }}
                                    >
                                      {data.amount} %
                                    </div>
                                  </Col>
                                );
                              })}
                            </Row>
                          </div>
                        </Fragment>
                        <Fragment>
                          <hr />
                          <div style={{ backgroundColor: "#FFFBEE" }}>
                            <div
                              style={{
                                paddingTop: "10px",
                                paddingLeft: "10px",
                              }}
                              className="d-flex justify-content-between"
                            >
                              <h6>Want to Donate to Udbhav?</h6>
                              <VendorLearnMore
                                heading="Donate to Udbhav"
                                paragraphText="‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy."
                              />
                            </div>
                            <br />
                            <Row
                              style={{ marginLeft: "3%" }}
                              className="superadmin-orderscomponent-main"
                            >
                              {donates.map((data) => {
                                return (
                                  <Col
                                    xs={4}
                                    sm={4}
                                    md={4}
                                    // className="p-0"
                                    align="center"
                                    onClick={() =>
                                      this.setDonation(data.id, data.amount)
                                    }
                                    key={data.id}
                                  >
                                    <div
                                      className={`take-away-order-select 
                                  ${donationId === data.id &&
                                        `take-away-order-select-selected`
                                        }`}
                                      style={{
                                        padding: "10px",
                                        // marginRight: "12%",
                                        marginBottom: "8%",
                                      }}
                                    >
                                      ₹ {data.amount}
                                    </div>
                                  </Col>
                                );
                              })}
                            </Row>
                          </div>
                        </Fragment>

                        <div style={{ paddingTop: "5%" }}>
                          <h6>Apply Promotions</h6>
                          <br />
                          <InputPromotion
                            offer_code={this.props.user_data}
                            apply_offer={(code) =>
                              this.checkAndApplyOffer(code)
                            }
                          />
                        </div>
                      </div>
                    )}

                    <Fragment>
                      {!isEmpty(this.props?.user_data?.order_items) &&
                        this.props?.user_data?.order_items.length > 0 ? (
                        <Fragment>
                          <hr />
                          <div style={{ paddingTop: "5%" }}>
                            <h3 className="f14-700">Order Summary</h3>
                            <br />
                            <div className="row mb-2">
                              <div className="col-8">
                                <h3 className="f12-400">Original Item Value</h3>
                              </div>
                              <div className="col-4 ">
                                <h3
                                  style={{
                                    textAlign: "end",
                                  }}
                                  className="f12-700"
                                >
                                  ₹
                                  {this.props?.user_data?.base_amount !==
                                    null &&
                                    this.props?.user_data?.base_amount !==
                                    undefined
                                    ? this.props?.user_data?.base_amount?.toFixed(
                                      2
                                    )
                                    : ""}
                                </h3>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-8">
                                <h3 className="f12-400">
                                  <div className="d-flex align-items-center">
                                    <p className="mr-1">Taxes</p>
                                    {this.props?.user_data?.gstAmount && (
                                      <InfoToolTip
                                        title={"Taxes"}
                                        hover={true}
                                        data={
                                          this.props?.user_data?.gstAmount || {}
                                        }
                                      />
                                    )}
                                  </div>
                                </h3>
                              </div>
                              <div className="col-4">
                                <h3
                                  className="f12-400"
                                  style={{
                                    textAlign: "end",
                                  }}
                                >
                                  {/* {calcTaxes(props.orderDetails)} */}₹
                                  {this.props &&
                                    this.props?.user_data &&
                                    this.props?.user_data?.gstAmount ? (
                                    <>
                                      {this.calcTaxes(
                                        this.props?.user_data?.gstAmount
                                      )}
                                    </>
                                  ) : (
                                    <>- </>
                                  )}
                                </h3>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-8">
                                <h3 className="f12-400">
                                  {" "}
                                  <div className="d-flex align-items-center">
                                    <p className="mr-1">Surcharges</p>
                                    {(this.props?.user_data?.surCharges && (
                                      <InfoToolTip
                                        title={"Surcharges"}
                                        hover={true}
                                        data={
                                          this.props?.user_data?.surCharges ||
                                          {}
                                        }
                                      />
                                    )) ||
                                      ""}
                                  </div>
                                </h3>
                              </div>
                              <div className="col-4">
                                <h3
                                  className="f12-400"
                                  style={{
                                    textAlign: "end",
                                  }}
                                >
                                  {this.props &&
                                    this.props?.user_data &&
                                    this.props?.user_data?.surCharges ? (
                                    <>
                                      ₹
                                      {this.calcTaxes(
                                        this.props?.user_data?.surCharges
                                      )}
                                    </>
                                  ) : (
                                    <>- </>
                                  )}
                                </h3>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-8">
                                <h3 className="f12-400">Donation</h3>
                              </div>
                              <div className="col-4">
                                <h3
                                  className="f12-400"
                                  style={{
                                    textAlign: "end",
                                  }}
                                >
                                  ₹
                                  {this.props &&
                                    this.props?.user_data &&
                                    this.props?.user_data?.donation &&
                                    this.props?.user_data?.donation?.amount
                                    ? this.props?.user_data?.donation?.amount?.toFixed(
                                      2
                                    )
                                    : 0}
                                </h3>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-8">
                                <h3 className="f12-400">Tip</h3>
                              </div>
                              <div className="col-4">
                                <h3
                                  className="f12-400"
                                  style={{
                                    textAlign: "end",
                                  }}
                                >
                                  ₹
                                  {this.props &&
                                    this.props?.user_data &&
                                    this.props?.user_data?.tip &&
                                    this.props?.user_data?.tip?.amount
                                    ? this.props?.user_data?.tip?.amount?.toFixed(
                                      2
                                    )
                                    : 0}
                                </h3>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-8">
                                <h3 className="f12-400">Discount</h3>
                              </div>
                              <div className="col-4">
                                <h3
                                  className="f12-400"
                                  style={{
                                    textAlign: "end",
                                  }}
                                >
                                  <div>
                                    {this.props &&
                                      this.props?.user_data &&
                                      this.props?.user_data?.discount &&
                                      this.props?.user_data?.discount?.amount !==
                                      0 ? (
                                      <span
                                        style={{
                                          color: "#EE3A23",
                                          fontSize: "19px",
                                        }}
                                      >
                                        -
                                      </span>
                                    ) : (
                                      ""
                                    )}{" "}
                                    ₹
                                    {this.props &&
                                      this.props?.user_data &&
                                      this.props?.user_data?.discount &&
                                      this.props?.user_data?.discount?.amount
                                      ? this.props?.user_data?.discount?.amount?.toFixed(
                                        2
                                      )
                                      : 0}
                                  </div>
                                </h3>
                              </div>
                            </div>
                            <table style={{ width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td colSpan={2}>
                                    <hr />
                                  </td>
                                </tr>
                                <tr
                                  style={{
                                    backgroundColor: "#F8F8F8",
                                    height: "60px",
                                  }}
                                >
                                  <td className="f14-700 pl-2">To be Paid</td>
                                  <td
                                    className="f14-700 pr-2"
                                    style={{ textAlign: "end" }}
                                  >
                                    ₹&nbsp;
                                    {!getPendingPayment(
                                      this.props?.user_data
                                    ) &&
                                      this.props?.user_data?.total_amount !==
                                      null &&
                                      this.props?.user_data?.total_amount !==
                                      undefined
                                      ? this.props?.user_data.total_amount.toFixed(
                                        2
                                      )
                                      : getPendingPayment(
                                        this.props?.user_data
                                      ).toFixed(2)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <hr />
                          <div className="mt-3 d-flex">
                            <button
                              type="button"
                              className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                              title="Cancel Button"
                              onClick={() =>
                                // this.props.size < 991 && this.props.showdefault
                                //   ? this.props.setDefault(false)
                                //   :
                                this.props.history.push("/orderdashboard")
                              }
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                              title="Save Button"
                              onClick={() => {
                                // if (!payment)
                                //   this.props.history.push("/orderpayment");

                                this.onClickProceed();
                              }}
                              disabled={[1,2,3,4,5,7,8,9].includes(user_data.payment_method) ? false : true}
                            >
                              Proceed
                            </button>
                          </div>
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </Fragment>
                    <hr />
                  </div>
                )}
                {/* {payment && (
                <PaymentSuccessModel
                  open={open}
                  props={this.props}
                  setOpenTract={this.setOpenTract}
                />
              )}
              {payment && (
                <OrderTrackEntry open={openTract} props={this.props} />
              )} */}
              </>
            )}
            <>
              {!isEmpty(this.props?.user_data?.order_items) &&
                this.props?.user_data?.order_items.length > 0 &&
                this.props.onlyPayment && (
                  <div className="mt-3 d-flex">
                    <button
                      type="button"
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                      title="Cancel Button"
                      onClick={() =>
                        // this.props.size < 991 && this.props.showdefault
                        //   ? this.props.setDefault(false)
                        //   :
                        this.props.history.push("/orderdashboard")
                      }
                    >
                      Cancel
                    </button>
                    {this.props.user_data.payment_method}
                    <button
                      type="button"
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                      title="Save Button"
                      onClick={() => {
                        this.onClickProceed();
                      }}
                    >

                      Proceed
                    </button>
                  </div>
                )}
            </>
          </Container>
        </React.Fragment>
      );
    } catch (e) {
      console.log(e);
    }
  }
}

const OrderTrackEntry = (props) => {
  try {
    return (
      <React.Fragment>
        <Modal show={props.open} size="md" centered>
          {/* <Modal.Header className="border-0" closeButton> */}
          {/* <Modal.Title className="f24_700_HelveticaNeue">
        Edit Customer Details
      </Modal.Title> */}
          {/* </Modal.Header> */}
          <Modal.Body>
            <h3>Order Success</h3>
            <br />
            <img
              src={require("../../../assets/images/superadmin/ordericon/success.svg")}
              width="65px"
            />{" "}
            <br />
            <br />
            <b>Your Order has been placed successfully</b>
            <br />
            <div className="mt-3 d-flex">
              <button
                type="button"
                className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                title="Track Button"
                onClick={() => {
                  props.props.history.push("/ordertrack");
                }}
              >
                Track Order
              </button>
              <button
                type="button"
                className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                title="Okay"
                onClick={() => {
                  // props.props.history.push("/ordertrack");
                }}
              >
                Okay
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};

export const PaymentSuccessModel = (props) => {
  const [success, setSuccess] = React.useState(false);
  let history = useHistory();
  const [orderData, setOrderData] = useState({});
  const clearAndRedirect = () => {
    store.dispatch({
      type: CLEAR_CART_DATA,
      //payload: formData,
    });
    store.dispatch({
      type: CLEAR_CART_DATA_USER_DATA,
      //payload: formData,
    });
    history.push("/orderdashboard");
  };
  useEffect(() => {
    setOrderData(props.data);
  }, [props.data]);

  const calcTaxes = (data) => {
    let tax = Object.values(data).reduce(
      (a, b) => parseFloat(a || 0) + parseFloat(b || 0),
      0
    );
    return tax.toFixed(2);
  };

  try {
    return (
      <React.Fragment>
        <Modal show={props.open} size="md" centered>
          <Modal.Header className="border-bottom-0" closeButton></Modal.Header>
          <Modal.Body className="p-0">
            <div
              className="px-4 py-3 mt-2"
              style={{ backgroundColor: "#FFFBEE" }}
            >
              <div className="row">
                <div className="col-6 f11-400">
                  Order ID:{" "}
                  <span className="f11-500" style={{ color: "#F85032" }}>
                    {orderData.order_id}
                  </span>
                </div>
                <div className="col-6" align="right">
                  <span
                    className="badge badge-warning f9-700 px-2 py-1"
                    style={{ borderRadius: "50px" }}
                  >
                    {" "}
                    {/* {orderData.order_type === 0
                      ? "Take Away"
                      : orderData.order_type === 1
                      ? "Curb Side"
                      : orderData.order_type === 2
                      ? "Skip the line"
                      : orderData.order_type === 3
                      ? "Dine In"
                      : null} */}
                    {ORDER_TYPE_NAME[orderData?.order_type]}
                  </span>
                </div>
              </div>
              <h1
                className="pt-1 pb-3"
                style={{
                  fontSize: "30px",
                  lineHeight: "35px",
                  fontFamily: "Roboto-Bold",
                  letterSpacing: "1px",
                  color: "#212121",
                }}
              >
                Payment{" "}
                {orderData.payment_method === 0 ||
                  orderData.payment_status === 1
                  ? "Success"
                  : "Failed"}
              </h1>
              <Row className="align-items-center">
                <Col xs={2}>
                  <img
                    src={require(`../../../assets/images/superadmin/ordericon/${orderData.payment_method === 0 ||
                        orderData.payment_status === 1
                        ? `success`
                        : `failed`
                      }.svg`)}
                    width="45px"
                    heigth="15px"
                  />{" "}
                </Col>
                <Col xs={10} className="pl-0 f12-400 opacity5">
                  {orderData.payment_method === 0 ||
                    orderData.payment_status === 1
                    ? "Your payment was sucessfull"
                    : "Your payment failed"}
                </Col>
              </Row>
            </div>
            <hr />
            <div
              className="px-4 py-3 mb-3"
              style={{ backgroundColor: "#F3F3F3" }}
            >
              <div className="row">
                <div className="col-6 f11-400" style={{ color: "#717171" }}>
                  Transaction ID :{" "}
                  <span className="f11-500" style={{ color: "#F85032" }}>
                    {orderData.transactional_id}
                  </span>
                </div>
              </div>
              <br />
              <Row>
                <Col xs={6}>
                  <h5 className="f16-700">
                    {orderData.now ? (
                      <> {moment().format("Do MMMM YYYY")}</>
                    ) : (
                      <>
                        {" "}
                        {moment(orderData.later_date).format(
                          "Do MMMM YYYY"
                        )}{" "}
                      </>
                    )}{" "}
                  </h5>
                  <p className="f10-400" style={{ color: "#757575" }}>
                    Date
                  </p>
                </Col>
                <Col xs={6}>
                  <h5 className="f16-700">
                    {orderData.now ? (
                      <> {moment().format("hh:mm A")}</>
                    ) : (
                      <> {moment(orderData.later_date).format("hh:mm A")} </>
                    )}{" "}
                  </h5>
                  <p className="f10-400" style={{ color: "#757575" }}>
                    Time
                  </p>
                </Col>
              </Row>
            </div>
            <div className="px-4 py-3" style={{ backgroundColor: "#F3F3F3" }}>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="f12-500 opacity5" style={{ width: "70%" }}>
                      Sub Total
                    </td>
                    <td className="f12-500 text-right" style={{ width: "30%" }}>
                      ₹{orderData.base_amount}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="f12-500 opacity5 pt-3 pb-3"
                      style={{ width: "70%" }}
                    >
                      Taxes
                    </td>
                    <td
                      className="f12-500 text-right pt-3 pb-3"
                      style={{ width: "30%" }}
                    >
                      ₹{" "}
                      {orderData && orderData.gstAmount ? (
                        <>{calcTaxes(orderData.gstAmount)}</>
                      ) : (
                        <> </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="f12-500 opacity5 pb-3"
                      style={{ width: "70%" }}
                    >
                      Surcharges
                    </td>
                    <td
                      className="f12-500 text-right pb-3"
                      style={{ width: "30%" }}
                    >
                      ₹
                      {orderData && orderData.surCharges ? (
                        <>{calcTaxes(orderData.surCharges)}</>
                      ) : (
                        <> </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="d-flex align-items-center f12-500 opacity5 pb-3"
                      style={{ width: "70%" }}
                    >
                      Tip&nbsp;&nbsp;
                      <VendorLearnMore
                        heading="Discount"
                        paragraphText="‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy."
                      />
                    </td>
                    <td
                      className="f12-500 text-right pb-3"
                      style={{ width: "30%" }}
                    >
                      ₹{" "}
                      {orderData && orderData.tip && orderData.tip.amount
                        ? orderData.tip.amount.toFixed(2)
                        : 0}
                      {/* {orderData?.tip?.amount || "0.00"} */}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="f12-500 opacity5 pb-3"
                      style={{ width: "70%" }}
                    >
                      Donation{" "}
                    </td>
                    <td
                      className="f12-500 text-right pb-3"
                      style={{ width: "30%" }}
                    >
                      ₹
                      {orderData &&
                        orderData.donation &&
                        orderData.donation.amount
                        ? orderData.donation.amount.toFixed(2)
                        : 0}
                      {/* {orderData.donation ? (
                        <>
                          {" "}
                          {orderData &&
                            orderData.donation &&
                            orderData.donation.amount}
                        </>
                      ) : (
                        "0.00"
                      )} */}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="f12-500 opacity5 d-flex align-items-center"
                      style={{ width: "70%" }}
                    >
                      Discount&nbsp;&nbsp;
                      <VendorLearnMore
                        heading="Discount"
                        paragraphText="‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy."
                      />
                    </td>
                    <td className="f12-500 text-right" style={{ width: "30%" }}>
                      {orderData &&
                        orderData.discount &&
                        orderData.discount.amount !== 0 ? (
                        <span
                          style={{
                            color: "#EE3A23",
                            fontSize: "19px",
                          }}
                        >
                          -
                        </span>
                      ) : (
                        ""
                      )}{" "}
                      ₹
                      {/* {orderData.discount ? (
                        <>
                          {" "} */}
                      {orderData &&
                        orderData.discount &&
                        orderData.discount.amount
                        ? orderData.discount.amount.toFixed(2)
                        : 0}
                      {/* {orderData &&
                            orderData.discount &&
                            orderData.discount.amount}{" "} */}
                      {/* </>
                      ) : (
                        "0.00"
                      )} */}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              className="px-4 py-3 mb-5 border-top"
              style={{ backgroundColor: "#F3F3F3" }}
            >
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="f16-700" style={{ width: "70%" }}>
                      Total Amount Paid
                    </td>
                    <td className="f16-700 text-right" style={{ width: "30%" }}>
                      {/* ₹&nbsp;{!isEmpty(orderData) && !getPendingPayment(orderData) &&
                          orderData?.total_amount !== null &&
                          orderData?.total_amount !== undefined
                          ? orderData.total_amount.toFixed(2)
                          : getPendingPayment(orderData).toFixed(
                            2
                          )} */}
                      ₹&nbsp;{orderData.total_amount}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr className="mb-0" />
            <div className="px-5 py-3" style={{ backgroundColor: "#FFFFFF" }}>
              <Button
                className="btn f18_500_HelveticaNeue py-3"
                style={{
                  backgroundColor: "#EE3A23",
                  width: "100%",
                  border: "none",
                }}
                type="button"
                title="Done"
                // onClick={() => {
                //   props.setOpenTract();
                // }}
                // onClick={() => history.push("/orderdashboard")}
                onClick={() => clearAndRedirect()}
              >
                Done
              </Button>
            </div>
            {/* <button
            type="button"
            class="onboarding_button_link_reusable onboarding_button_link_reusable_red w-100"
            title="Done"            
            onClick={() => clearAndRedirect()}
          >
            Done
          </button> */}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};
const InputPromotion = (props) => {
  const classes = useStyles();

  const [offerCode, setOfferCode] = useState("");

  useEffect(() => {
    if (props && props.offer_code && props.offer_code.isOfferApplied) {
      setOfferCode(props.offer_code.coupon_code);
    }
  }, [props.offer_code.isOfferApplied]);

  const removeOffer = () => {
    const formData = {};
    formData.isOfferApplied = false;
    store.dispatch({
      type: APPLY_OFFER_VENDOR,
      payload: formData,
    });
  };
  try {
    return (
      <React.Fragment>
        <div>
          <Paper className={classes.root}>
            <InputBase
              disabled={
                props && props.offer_code && props.offer_code.isOfferApplied
              }
              className={classes.input}
              placeholder="Write Here"
              inputProps={{ "aria-label": "Write Here" }}
              value={offerCode.toUpperCase()}
              onChange={(e) => setOfferCode(e.currentTarget.value)}
            />
            <IconButton className={classes.iconButton} aria-label="apply">
              <button
                onClick={() =>
                  props && props.offer_code && props.offer_code.isOfferApplied
                    ? removeOffer()
                    : props.apply_offer(offerCode)
                }
                className="btn"
                style={{
                  backgroundColor: "#2196F3",
                  color: "#ffffff",
                  borderRadius: "15px",
                  boxShadow: "0px 5px 8px #6E6E6E57",
                }}
              >
                {props && props.offer_code && props.offer_code.isOfferApplied
                  ? "Remove"
                  : "Apply"}
              </button>
            </IconButton>
          </Paper>
        </div>
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};

const tips = [
  { id: 0, amount: 0 },
  { id: 1, amount: 5 },
  { id: 2, amount: 10 },
  { id: 3, amount: 20 },
  // { id: 4, title: "Custom" },
];

const donates = [
  { id: 0, amount: 0 },
  { id: 1, amount: 10 },
  { id: 2, amount: 20 },
  { id: 3, amount: 30 },
  { id: 4, amount: 40 },
  { id: 5, amount: 50 },
  { id: 6, amount: 100 },
  // { id: 4, title: "Custom" },
];

const suggestions = [
  {
    id: 0,
    title: "Pepsi (250ml)",
    type: 0,
    rating: 4.2,
    price: 450,
    best: true,
  },
  {
    id: 1,
    title: "7up (500ml)",
    type: 0,
    rating: 4.2,
    price: 450,
    best: true,
  },
  {
    id: 2,
    title: "Pepsi (250ml)",
    type: 0,
    rating: 4.2,
    price: 450,
    best: true,
  },
];

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  cart_data: state.vendorOrdering.vendor_order_data.order_items,
  user_data: state.vendorOrdering.vendor_order_data,
  order_id: state.vendorOrdering.order_id,
  vendor_filtered_menu: state.vendorOrdering.vendor_filtered_menu
});

// const mapDispathToProps = (dispatch) => ({
//   addTips: (tipamt) => {
//     dispatch({ type: SET_ORDER_TIP, id: tipamt });
//   },
//   // updateProduct: (id) => {
//   //   dispatch({ type: "UPDATE_PRODUCT", id: id });
//   // },
// });

export default withRouter(
  connect(mapStateToProps, {
    create_order_vedor_side,
    razor_pay_create_order,
    razor_payment,
    edit_order_vendor_side_payment,
    apply_offer_code,
    editTransaction,
  })(ReRightComponentOrderRequest)
);
